<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import PostalCode from '$lib/PageSections/Forms/PostalCode/PostalCode.svelte';
	import GetIndowSteps from '$lib/PageSections/GetIndowSteps/GetIndowSteps.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';
	import TrustedChoice from '$lib/PageSections/TrustedChoice/TrustedChoice.svelte';

	let { data = null, form = null } = $props();
</script>

<Section>
	<h1 class="text-left">Get A Free Estimate</h1>
	<p class="text-left">
		Fill out the form below and tell us about your windows. We'll answer any
		questions you have, provide you with an estimate at our best pricing, and
		help you determine if Indow is the right fit for the issues you're facing.
	</p>
</Section>

<PostalCode {data} {form} showMap />

<Section backgroundColor="blue">
	<GetIndowSteps />
</Section>

<Reviews />
<TrustedChoice />
